import HtmlData from 'apps/frontend/components/Shared/HtmlData/HtmlData';
import axios from 'axios';
import Image from 'next/image';
import { useState, useEffect,useRef } from 'react';
import convert from 'xml-js';
import PlayerIcon from '../../styles/images/carbon_play-filled.png';
import { GetArabicFormattedDateAndTime } from 'apps/frontend/services/Util';
import GooglePodcastIcon from '../../styles/images/image 2.png';
import ApplePodcastIcon from '../../styles/images/image 1.png';
import ShareIcon from '../../styles/images/basil_share-outline.png';
import PodcastBannerImgs from '../../styles/images/Group 17.png';
import Link from 'next/link';
import { requests, siteUrl } from 'apps/frontend/services/Requests';
import xIcon from '../../styles/images/x-twitter.svg';
import facebookIcon from '../../styles/images/facebook-f.svg';
import whatsAppIcon from '../../styles/images/whatsapp.svg';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'next-share';
import { useRouter } from 'next/router';
import pauseIcon from '../../styles/images/circle-pause-solid (1).svg';
import GetData from 'apps/frontend/services/GetData';

const Podcast = ({
  episode,
  title,
  description,
  googlePodcastLink,
  applePodcastLink,
  imgUrl,
  PodcastBannerImg,
  name,
  innerImgUrl,
  total,
}) => {
  const [activeEpisodeIndex, setActiveEpisodeIndex] = useState(null);
  const [activeShareIndex, setActiveShareIndex] = useState(null);
  const [totalEpisode, setTotalEpisode] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [segments, setSegments] = useState([]);
  const perPage = 10;
  const currentPage = useRef(0);


  const toggleAudioVisibility = (index) => {
    setActiveEpisodeIndex(index === activeEpisodeIndex ? null : index);
    setActiveShareIndex(null);
  };

  const toggleShareVisibility = (index) => {
    setActiveShareIndex(index === activeShareIndex ? null : index);
    setActiveEpisodeIndex(null);
  };

  useEffect(() => {
    setTotalEpisode(total);
  }, [total]);

  useEffect(() => {
    console.log('RELOADING');
    currentPage.current = 0;
    loadMoreEpisodes();
  }, [episode]);

  useEffect(() => {
   console.log('segments===>',segments);
  }, [segments]);

  const loadMoreEpisodes = () => {
    const nextPage = currentPage.current + 1;
    const newSegments = episode.slice(0, nextPage * perPage);

    setSegments(newSegments);
    currentPage.current = nextPage;
    setHasMore(newSegments.length < total);
  };

  const { asPath } = useRouter();
  const origin =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : '';

  const URL = `${origin}${asPath}`;

  const handlePage = () => {
    console.log('GETTTING MOre');
  };

  return (
    <>
      <div className="container mt-4 mb-4">
      </div>
      <div className="container">
        <div className="text-center mb-4">
          <Image
            className="img-fluid"
            style={{ backgroundColor: 'black' }}
            src={PodcastBannerImgs}
          />
        </div>
        <div className="PageBuilder-pageRow">
          <ul style={{ padding: 0 }}>
            <div
              style={{
                width: '100%',
                padding: '14px 1%',
                marginBottom: '1%',
                borderRadius: '14px',
              }}
            >
              <h4>{title}</h4>
              <p style={{ opacity: '0.7' }}>{description}</p>
            </div>
            <div className="podcastLegend">
              <div className="podcastSubLedgend">{'متاح على'}</div>
              <div
                style={{
                  padding: '2%',
                  paddingTop: '3%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <Link href={googlePodcastLink}>
                  <div style={{ cursor: 'pointer' }}>
                    <Image src={GooglePodcastIcon} />
                  </div>
                </Link>

                <Link href={applePodcastLink}>
                  <div style={{ cursor: 'pointer', paddingRight: '20%' }}>
                    <Image src={ApplePodcastIcon} />
                  </div>
                </Link>
              </div>
            </div>
            <h4
              style={{ margin: '2%', opacity: '0.8' }}
            >{`${episode.length} حلقات`}</h4>

            {segments.map((item, index) => (
              <li key={index} className="podcastList">
                <div
                  className="newsText"
                  style={{ width: '50%', flex: '3 1', padding: '5px 5px 0' }}
                >
                  <h4 style={{ opacity: '0.8', lineHeight: '21.78px' }}>
                    {item.title}
                  </h4>
                  <HtmlData data={item.description} />
                  <div className="infoItem">{item.createdAt}</div>
                  <div
                    style={{
                      marginBottom: '1%',
                      paddingTop: '12%',
                      borderBottom: '2px solid #D6D6D6',
                    }}
                  ></div>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    {activeEpisodeIndex !== index && (
                      <Image
                        src={PlayerIcon}
                        onClick={() => toggleAudioVisibility(index)}
                      />
                    )}
                    {activeEpisodeIndex === index && (
                      <>
                        <div className="podcastPauseIcon">
                          <img
                            src={pauseIcon}
                            width={32}
                            height={32}
                            onClick={() => toggleAudioVisibility(index)}
                          />
                        </div>

                        <div className="podcastAudio">
                          <audio autoPlay controls style={{ width: '100%' }}>
                            <source src={item.episodeUrl} type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        </div>
                      </>
                    )}
                    {activeShareIndex !== index && (
                      <div>
                        <Image
                          src={ShareIcon}
                          style={{ cursor: 'pointer' }}
                          onClick={() => toggleShareVisibility(index)}
                        />
                      </div>
                    )}
                    {activeShareIndex === index && (
                      <div style={{ display: 'flex', height: '100%' }}>
                        <div
                          style={{ cursor: 'pointer', fontSize: 'X-large' }}
                          onClick={() => toggleShareVisibility(null)}
                        >
                          &#x2715;
                        </div>
                        <div className="podcastIcon">
                          <TwitterShareButton url={URL} title={item?.title}>
                            <Image
                              className=""
                              width={25}
                              height={25}
                              style={{
                                margin: '0.1em',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                cursor: 'pointer',
                              }}
                              src={xIcon}
                            />
                          </TwitterShareButton>
                          <FacebookShareButton
                            url={URL}
                            quote={item?.title}
                            hashtag={'#cnbc'}
                          >
                            {' '}
                            <Image
                              className=""
                              width={25}
                              height={25}
                              src={facebookIcon}
                              style={{
                                margin: '0.1em',
                                padding: '5%',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                cursor: 'pointer',
                              }}
                            />
                          </FacebookShareButton>
                          <WhatsappShareButton
                            url={URL}
                            title={item?.title}
                            separator=":: "
                          >
                            <Image
                              className=""
                              width={25}
                              height={25}
                              src={whatsAppIcon}
                              style={{
                                margin: '0.1em',
                                padding: '5%',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                cursor: 'pointer',
                              }}
                            />
                          </WhatsappShareButton>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ width: '15%', marginRight: '1%' }}>
                  <Image
                    style={{ borderRadius: '25px' }}
                    src={item.imageUrl}
                    width={130}
                    height={130}
                  ></Image>
                </div>
              </li>
            ))}
          </ul>
          <div className="PageBuilder-sidebar cate_sidebar">
            <div
              className="bannerAddMedia"
              style={{ marginTop: '-90px', width: '70%' }}
            >
              <div className="text-center w_sm_100  bnner_add hide_div_mobile undefined">
                <div className="podcastMainImage">
                  <Image
                    src={innerImgUrl || imgUrl}
                    width={200}
                    height={200}
                    style={{
                      backgroundColor: '#372F1B',
                      borderRadius: '20px',
                      border: '2px solid #FFFFFF',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {hasMore == true && (
          <div
            className="text-center mt-3 mb-4 more_btn"
            onClick={() => loadMoreEpisodes()}
          >
            <button className="btn btn-outline-primary">المزيد</button>
          </div>
        )}
      </div>
    </>
  );
};

export const getServerSideProps = async (context) => {
  const { slug } = context.query;
  const response = await GetData(
    `${requests.podcastRSS}/${slug}`,
    {},
    'get',
    false
  );
  if (response.statusCode === 404) {
    return {
      redirect: {
        destination: `${siteUrl}podcast`,
        permanent: false,
      },
    };
  }
  const { data } = response;
  const {
    name = '',
    innerImgUrl = '',
    description,
    rss_feed: rss_feed = 'https://feeds.buzzsprout.com/1373698.rss',
    title = '',
    imgUrl = 'http://8.233.159.33/cnbc-staging/content/images/8361634675.jpg',
    apple_podcasts:
      applePodcastLink = 'https://podcasts.apple.com/ae/podcast/%D9%85%D9%86-%D8%A7%D9%84%D8%A3%D9%84%D9%81-%D8%A5%D9%84%D9%89-%D8%A7%D9%84%D9%8A%D8%A7%D8%A1/id1533654074',
    google_podcasts:
      googlePodcastLink = 'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5idXp6c3Byb3V0LmNvbS8xMzczNjk4LnJzcw==',
  } = data;

  const arabicDateformat = (date) => {
    const newDate = new Date(date);
    return GetArabicFormattedDateAndTime(newDate.toISOString());
  };

  // console.log('==>',data);
  try {
    const response = await axios.get(rss_feed);
    // console.log('1.parse=====>',response.data);
    const parse = convert.xml2json(response.data, { compact: true, spaces: 4 });
    const {
      rss: {
        channel: { item },
      },
    } = JSON.parse(parse);
    // console.log('2.parse=====>',parse);
    const episodes = item.map(
      ({
        'itunes:title': { _text: title },
        description: { _cdata: description },
        'itunes:image': { _attributes: { href: imageUrl = '' } = {} } = {},
        enclosure: { _attributes: { url: episodeUrl = '' } = {} } = {},
        pubDate: { _text: pubDate },
      }) => ({
        title: title || '',
        description: description || '',
        imageUrl: imageUrl || imgUrl,
        episodeUrl: episodeUrl || '',
        createdAt: arabicDateformat(pubDate) || new Date(),
      })
    );
    return {
      props: {
        total: episodes?.length,
        episode: episodes,
        title,
        name,
        innerImgUrl,
        description: data.description,
        googlePodcastLink,
        applePodcastLink,
        imgUrl,
        PodcastBannerImg:
          'https://storage.googleapis.com/cnbc-staging/content/images/cf8f10dc0da.png',
      },
    };
  } catch (error) {
    console.error('Error fetching or parsing podcast feed:', error);
    return {
      props: {
        total: 0,
        episode: [],
        title,
        name,
        innerImgUrl,
        description: data.description,
        googlePodcastLink,
        applePodcastLink,
        imgUrl,
        PodcastBannerImg:
          'https://storage.googleapis.com/cnbc-staging/content/images/cf8f10dc0da.png',
      },
    };
  }
};

export default Podcast;
